<template>
  <div>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
        >
          <el-form-item label="关键字" prop="number">
            <el-input
              size="small"
              v-model="filter.query"
              @keyup.enter.native="requestDeviceQuests"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="number">
            <el-select
              v-model="filter.status"
              size="small"
              placeholder="请选择"
              style="width: 100%"
              :clearable="true"
            >
              <el-option
                v-for="(value, key) in statusOptions"
                :key="key"
                :label="value"
                :value="parseInt(key)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestDeviceQuests()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="startDeviceQuest"
          v-permission="Auth.deviceQuestCreate"
          >发布请求</el-button
        >
        <file-button
          v-permission="Auth.usedDeviceIE"
          style="float: right"
          obj="device_quest"
          :filter="filter"
          :importButton="false"
          class="mobile-hide"
        ></file-button>
      </div>
      <el-table v-if="!isMobile()" :data="quests" v-loading="loading">
        <el-table-column label="设备信息" prop="material_desc">
          <template slot-scope="scope">
            <el-tag size="mini">
              {{ scope.row.customer.name }}
            </el-tag>
            <br />
            {{ scope.row.material_desc }}
            <template v-if="scope.row.device_number">
              <br />
              设备号：{{ scope.row.device_number }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark"> </el-table-column>
        <el-table-column
          label="数量"
          align="center"
          prop="quantity"
          width="100px"
        >
        </el-table-column>
        <el-table-column label="请求来源" v-if="auth.isPlatformUser()">
          <template slot-scope="scope">
            <div>{{ scope.row.dealer.name }}</div>
            <div>
              <span v-if="scope.row.contact_name.length > 0">
                {{ scope.row.contact_name }}
              </span>
              <span v-if="scope.row.contact_mobile.length > 0">
                {{ scope.row.contact_mobile }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="处理结果" prop="manage_result" align="center">
          <template slot-scope="scope">
            {{ scope.row.status == 100 ? scope.row.manage_result : '待处理' }}
          </template>
        </el-table-column>
        <el-table-column label="发布日期" width="120px" align="center">
          <template slot-scope="scope">
            <span>
              {{ formatTime(scope.row.created_at) }}
            </span>
          </template></el-table-column
        >
        <el-table-column
          label="申请人"
          width="120px"
          align="center"
          v-if="isAdmin"
        >
          <template slot-scope="scope">
            {{ scope.row.user.name }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80px" align="center">
          <template slot-scope="scope">
            <status-tag
              :name="DeviceQuestStatusMap[scope.row.status].name"
              :type="DeviceQuestStatusMap[scope.row.status].type"
            >
            </status-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200px"
          ><template slot-scope="scope">
            <template v-if="userInfo.id == scope.row.user_id">
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  v-if="scope.row.status == 1"
                  v-permission="Auth.deviceQuestHandle"
                  plain
                  @click="handleDeviceQuest(scope.$index, 2)"
                  >提交</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  v-if="scope.row.status == 2"
                  v-permission="Auth.deviceQuestHandle"
                  plain
                  @click="handleDeviceQuest(scope.$index, 1)"
                  >撤回</el-button
                >
                <el-button
                  type="info"
                  size="mini"
                  v-if="scope.row.status != 99 && scope.row.status != 100"
                  v-permission="Auth.deviceQuestHandle"
                  plain
                  @click="handleDeviceQuest(scope.$index, 99)"
                  >关闭</el-button
                >
              </div>
              <div class="mt-10" v-if="scope.row.status == 1">
                <el-button
                  size="mini"
                  plain
                  type="primary"
                  v-permission="Auth.deviceQuestUpdate"
                  @click="startDeviceQuest(scope.row, scope.$index)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  plain
                  type="danger"
                  v-permission="Auth.deviceQuestDelete"
                  @click="deleteQuest(scope.$index)"
                  >删除</el-button
                >
              </div></template
            >
            <el-button
              type="primary"
              size="mini"
              class="mt-10"
              v-if="scope.row.status == 2"
              v-permission="Auth.deviceQuestManage"
              plain
              @click="startManage(scope.$index)"
              >处理</el-button
            >
          </template></el-table-column
        ></el-table
      >
      <ul v-else class="list-style">
        <li v-for="(item, index) in quests">
          <div>
            <el-tag size="mini">{{ item.customer.name }}</el-tag>
            <br />
            {{ item.material_desc }}
            <br />
            设备号：{{ item.device_number }}
          </div>
          <div class="font-12">数量：{{ item.quantity }}</div>
          <div class="font-12" v-if="auth.isPlatformUser()">
            来源：{{ item.dealer.name }}
          </div>
          <div class="font-12">
            联系人：{{ item.contact_name
            }}{{
              item.contact_mobile.length > 0
                ? '（' + item.contact_mobile + '）'
                : ''
            }}
          </div>
          <div class="font-12">备注：{{ item.remark }}</div>
          <div class="flex-row-between mt-10">
            <status-tag
              class="font-12 mr-10"
              :name="DeviceQuestStatusMap[item.status].name"
              :type="DeviceQuestStatusMap[item.status].type"
            >
            </status-tag>
            <span class="font-12" v-if="item.status == 100">{{
              item.manage_result
            }}</span>
            <div v-else class="flex-row">
              <template v-if="userInfo.id == item.user_id">
                <el-button
                  type="primary"
                  size="mini"
                  v-if="item.status == 1"
                  v-permission="Auth.deviceQuestHandle"
                  plain
                  @click="handleDeviceQuest(index, 2)"
                  >提交</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  v-if="item.status == 2"
                  v-permission="Auth.deviceQuestHandle"
                  plain
                  @click="handleDeviceQuest(index, 1)"
                  >撤回</el-button
                >
                <el-button
                  type="info"
                  size="mini"
                  v-if="item.status != 99 && item.status != 100"
                  v-permission="Auth.deviceQuestHandle"
                  plain
                  @click="handleDeviceQuest(index, 99)"
                  >关闭</el-button
                >
                <template class="mt-10" v-if="item.status == 1">
                  <el-button
                    type="primary"
                    size="mini"
                    v-permission="Auth.deviceQuestUpdate"
                    @click="startDeviceQuest(item, index)"
                    >编辑</el-button
                  >
                  <el-button
                    type="danger"
                    size="mini"
                    v-permission="Auth.deviceQuestDelete"
                    @click="deleteQuest(index)"
                    >删除</el-button
                  >
                </template></template
              >
              <el-button
                type="primary"
                size="mini"
                v-if="item.status == 2"
                v-permission="Auth.deviceQuestManage"
                plain
                @click="startManage(index)"
                >处理</el-button
              >
            </div>
          </div>
        </li>
      </ul>
      <div class="mt-20">
        <el-pagination
          class="mt-20"
          :page-size="filter.size"
          :current-page.sync="filter.page"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <device-quest-former
      :model="formerModel"
      :show.sync="formerVisible"
      @created="createdDeviceQuest"
      @updated="updatedDeviceQuest"
    ></device-quest-former>
    <manage-former
      :show.sync="manageVisible"
      :model="manageModel"
      :quest="manageQuest"
      @done="manageDone"
    ></manage-former>
  </div>
</template>

<script>
import DeviceQuestFormer from './former'
import ManageFormer from './manage'
import { isMobile, formatTime, clone } from '@/util/index'
import {
  deleteDeviceQuest,
  deviceQuestHandle,
  deviceQuestList,
} from '../../service/getData'
import auth from '../../util/auth'
import { DeviceQuestStatusMap } from '../../config/global'
import store from '@/store/store'

export default {
  components: { DeviceQuestFormer, ManageFormer },
  props: {
    category: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      quests: [],
      auth,
      isMobile,
      formatTime,
      loading: false,
      formerVisible: false,
      userInfo: store.getters.userInfo,
      formerModel: {},
      submiting: false,
      manageVisible: false,
      DeviceQuestStatusMap,
      editIndex: -1,
      manageIndex: -1,
      manageModel: {},
      manageQuest: {},
      total: 0,
      filter: {
        query: '',
        page: 1,
        status: null,
        size: 20,
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.requestDeviceQuests()
    },
  },
  computed: {
    isAdmin() {
      return (
        this.userInfo.dealer_id > 0 &&
        (this.userInfo.mark == 1 || this.userInfo.mark == 2)
      )
    },
    statusOptions() {
      if (auth.isPlatformUser()) {
        return {
          2: '处理中',
          100: '已结束',
        }
      } else {
        return {
          1: '未提交',
          2: '处理中',
          99: '已关闭',
          100: '已结束',
        }
      }
    },
  },
  created() {
    this.filter = {
      query: this.$route.query.query || '',
      status: parseInt(this.$route.query.status) || null,
      page: parseInt(this.$route.query.page || 1),
      size: parseInt(this.$route.query.size || 20),
    }
    this.requestDeviceQuests()
  },
  methods: {
    async requestDeviceQuests() {
      this.$router.replace({
        query: this.filter,
      })

      this.filter.category = this.category

      this.loading = true
      let data = clone(this.filter)
      data.page = data.page - 1
      // data.category = this.category

      data.status = data.status || 0

      let res = await deviceQuestList(data)
      if (res.code == 0) {
        this.quests = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    createdDeviceQuest(d) {
      this.quests.unshift(d)
    },
    updatedDeviceQuest(d) {
      if (this.editIndex >= 0) {
        this.quests.splice(this.editIndex, 1, d)
      }
    },
    handleDeviceQuest(index, status) {
      let title = ''
      if (status == 2) {
        title = '确认提交请求？'
      } else if (status == 1) {
        title = '确认撤回请求？'
      } else if (status == 99) {
        title = '确认关闭请求？'
      } else {
        return
      }
      this.$confirm(title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let that = this
        let dq = this.quests[index]
        let data = {
          device_quest_id: dq.id,
          status: status,
        }
        this.submiting = true

        deviceQuestHandle(data).then((res) => {
          if (res.code == 0) {
            that.quests.splice(index, 1, res.data)
            that.$message.success('操作成功！')
          }
          that.submiting = false
        })
      })
    },
    deleteQuest(index) {
      let dq = this.quests[index]
      let that = this
      this.$confirm('确定删除此请求？').then(() => {
        deleteDeviceQuest(dq.id).then((res) => {
          if (res.code == 0) {
            that.$message.success('删除成功')
            that.quests.splice(index, 1)
          }
        })
      })
    },
    reset() {
      this.filter = {
        query: '',
        page: 1,
        size: 20,
      }
      this.requestDeviceQuests()
    },
    startDeviceQuest(model, index) {
      if (model.id > 0) {
        this.editIndex = index
        this.formerModel = clone(model)
        if (!this.formerModel.customer_id) {
          this.formerModel.customer_id = ''
        }
      } else {
        this.formerModel = {
          material_desc: '',
          device_number: '',
          quantity: 1,
          remark: '',
          pics: [],
          category: this.category,
          contact_mobile: this.userInfo.phone_number,
          contact_name: this.userInfo.name,
          customer_id: '',
        }
      }

      this.formerVisible = true
    },
    startManage(index) {
      this.manageIndex = index
      let dq = this.quests[index]
      this.manageModel = {
        device_quest_id: dq.id,
      }
      this.manageQuest = dq
      this.manageVisible = true
    },
    manageDone(dq) {
      if (this.manageIndex >= 0) {
        this.quests.splice(this.manageIndex, 1, dq)
      }
    },
  },
}
</script>